<!--赖传峰-->
<!--2023/4/6-->
<template>
  <header
    v-if="visible"
    class="header"
  >
    <div class="header-left">
      <a
        class="open-sidebar"
        @click="layoutStore.sidebarMobileVisible = true"
      />
      <a
        :href="RoutePathOfDrive.ALL"
        class="logo"
      />
    </div>
    <div class="login-entry-placeholder">
      <ClientOnly>
        <PPButton
          :loading="openAppLoading"
          class="open-app"
          height="36px"
          type="primary"
          @click="handleOpenApp"
        >
          {{ $t('open-app') }}
        </PPButton>
      </ClientOnly>
    </div>
  </header>

  <ClientOnly>
    <AsyncGuidePopup
      ref="guidePopupRef"
      @to-app="handleToApp"
    />
  </ClientOnly>
  
</template>

<script
  lang="ts"
  setup
>

import {
  computed,
  isPikPakClient,
  ref,
  useCookie,
  defineAsyncComponent,
} from '#imports'
import PPButton from '@/components/PPButton.vue'
import { shareTrackParams } from '@/components/share/share.script'
import useShareId from '@/composables/useShareId'
import track from '@/track/webShare'
import toApp from '@/utils/toApp'
import { useLayout } from '~/store/layout'
import {
  RoutePathOfDrive,
  StorageKey,
} from '~/types/enum'

const AsyncGuidePopup = defineAsyncComponent(() => import('./GuidePopup.vue'))

const layoutStore = useLayout()
const shareId = useShareId()
const openAppLoading = ref(false)
const guidePopupRef = ref<typeof AsyncGuidePopup>()
const visible = computed(() => !isPikPakClient())

const handleToApp = () => {
  const pwdCode = useCookie(`${StorageKey.SHARE_PWD_CODE}_${shareId.value}`).value
  window.location.href = toApp.share(shareId.value, pwdCode || '')
}

const handleOpenApp = () => {
  handleToApp()
  openAppLoading.value = true
  track.web_share_page_click({ ...shareTrackParams(), button: 'open_app' })
  setTimeout(() => {
    openAppLoading.value = false
    guidePopupRef.value?.show()
  }, 1000)
}
</script>

<style
  lang="less"
  scoped
>
@import 'driveHeader.style';
</style>
